import { render, staticRenderFns } from "./UserPayments.vue?vue&type=template&id=9a31ba5c&"
import script from "./UserPayments.vue?vue&type=script&lang=js&"
export * from "./UserPayments.vue?vue&type=script&lang=js&"
import style0 from "./UserPayments.vue?vue&type=style&index=0&id=9a31ba5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports